class FacetFiltersForm2 extends HTMLElement {
    constructor() {
        super();

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 800);
    
        const facetForm = this.querySelector('form');
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FacetFiltersForm2.searchParamsInitial;
            if (searchParams === FacetFiltersForm2.searchParamsPrev) return;
            FacetFiltersForm2.renderPage(searchParams, null, false);
        };
        window.addEventListener('popstate', onHistoryChange);
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FacetFiltersForm2.searchParamsPrev = searchParams;
        const sections = FacetFiltersForm2.getSections();
        const productContainer = document.getElementById('product-grid');
    
        productContainer.classList.add('loading');
    
        sections.forEach((section) => {
            const url = new URL(window.location);
            const params = new URLSearchParams(searchParams);
    
            if (params.has('category')) {
                const categoryValue = params.get('category');
    
                // Split the pathname into segments
                const pathSegments = url.pathname.split('/');
                // Replace the last segment with the category value
                pathSegments[pathSegments.length - 1] = categoryValue;
                // Join the segments back into a pathname
                url.pathname = pathSegments.join('/');
    
                params.delete('category');
            }
    
            const updatedSearchParams = params.toString();
            const finalUrl = `${url.pathname}?section_id=${section.section}&${updatedSearchParams}`;
    
            const filterDataUrl = (element) => element.url === finalUrl;
    
            FacetFiltersForm2.filterData.some(filterDataUrl)
                ? FacetFiltersForm2.renderSectionFromCache(filterDataUrl, event)
                : FacetFiltersForm2.renderSectionFromFetch(finalUrl, event);
        });
    
        if (updateURLHash) FacetFiltersForm2.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
            const html = responseText;
            FacetFiltersForm2.filterData = [...FacetFiltersForm2.filterData, { html, url }];
            FacetFiltersForm2.renderProductGridContainer(html);
            if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FacetFiltersForm2.filterData.find(filterDataUrl).html;
        FacetFiltersForm2.renderProductGridContainer(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    }

    static renderProductGridContainer(html) {
        document.getElementById('product-grid').innerHTML = new DOMParser()
            .parseFromString(html, 'text/html')
            .getElementById('product-grid').innerHTML;

        document
            .getElementById('product-grid')
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => {
            element.classList.add('scroll-trigger--cancel');
            });
    }

    static updateURLHash(searchParams) {
        const url = new URL(window.location);
        const params = new URLSearchParams(searchParams);
    
        if (params.has('category')) {
            const categoryValue = params.get('category');

            // Split the pathname into segments
            const pathSegments = url.pathname.split('/');
            // Replace the last segment with the category value
            pathSegments[pathSegments.length - 1] = categoryValue;
            // Join the segments back into a pathname
            url.pathname = pathSegments.join('/');
    
            params.delete('category');
        }
    
        history.pushState({ searchParams }, '', `${url.pathname}${params.toString() ? '?'.concat(params.toString()) : ''}`);
    }

    static getSections() {
        return [
            {
            section: document.getElementById('product-grid').dataset.id,
            },
        ];
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FacetFiltersForm2.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('facet-filter-form-2 form');
    
        const forms = [];

        sortFilterForms.forEach((form) => {
            forms.push(this.createSearchParams(form));
        });
        this.onSubmitForm(forms.join('&'), event);
      
      }
}

FacetFiltersForm2.filterData = [];
FacetFiltersForm2.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm2.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filter-form-2', FacetFiltersForm2);
FacetFiltersForm2.setListeners();